import { FILTER_TYPES } from 'common/constants/filters';
import { keys, uniq } from 'lodash';
import { PROJECTS_FILTERS_CONTEXTS_NAMES } from '../../../contexts';
import { TRACKING } from 'common/constants/constants';
import { FILTER_SET_MODEL } from '../FilterSet/FilterSet.model';

export const supportedFiltersTracking = [
  PROJECTS_FILTERS_CONTEXTS_NAMES.PROJECT_PROGRESSION,
  PROJECTS_FILTERS_CONTEXTS_NAMES.RESOURCE_ALLOCATION,
  PROJECTS_FILTERS_CONTEXTS_NAMES.INVESTMENT_CARVING
];

export const mapContextToTrackingPage = {
  [PROJECTS_FILTERS_CONTEXTS_NAMES.PROJECT_PROGRESSION]:
    TRACKING.PAGES.PROJECT_PROGRESSION,
  [PROJECTS_FILTERS_CONTEXTS_NAMES.RESOURCE_ALLOCATION]:
    TRACKING.PAGES.RESOURCE_ALLOCATION,
  [PROJECTS_FILTERS_CONTEXTS_NAMES.INVESTMENT_CARVING]:
    TRACKING.PAGES.INVESTMENT_PROFILE
};

const mapFilterKeyToTrackingKey = {
  [FILTER_TYPES.PROJECTS]: 'project',
  [FILTER_TYPES.BOARD]: 'board',
  [FILTER_TYPES.LABEL]: 'label',
  [FILTER_TYPES.FIX_VERSION]: 'fix_version',
  [FILTER_TYPES.ISSUE_PARENT_1]: 'issue_parent_1',
  [FILTER_TYPES.ISSUE_PARENT_2]: 'issue_parent_2',
  [FILTER_TYPES.ORGANIZATION_TEAMS]: 'linearb_team',
  [FILTER_TYPES.ORGANIZATION_PDT]: 'linearb_project'
};

export const convertFiltersToPayloadKeys = filters =>
  uniq(
    keys(filters).map(
      filterKey => mapFilterKeyToTrackingKey[filterKey] || 'custom_field'
    )
  );

export const getFilterSetTrackingPayload = filterSet => ({
  filter_set_type: filterSet?.[FILTER_SET_MODEL.TYPE],
  filter_set_name: filterSet?.[FILTER_SET_MODEL.NAME],
  filter_set_visibility: filterSet?.[FILTER_SET_MODEL.VISIBILITY],
  filter_set_due_date: filterSet?.metadata?.[FILTER_SET_MODEL.METADATA.DUE_DATE]
});
